import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, Tabs, Tab,
	FormControl, FormGroup
} from '@material-ui/core';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';
import {
	SetFormState,
} from '../../../actions/AlgorithmsActions';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const ByCoordinates = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.algorithmsReducer.formState);

	const _handleChange = (event) => {
		event.persist();
		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value,
			},
			touched: {
				...formState.touched,
				[event.target.name]: true,
			},
		});
	};

	return (
		<div className={classes.fields}>
			{/* New row */}
			<Grid container spacing={3}>
				<Grid item md={2} xs={2}>
					<TextField
						id="northEast"
						name="northEast"
						label="NorthEast"
						InputProps={{
							readOnly: true,
						}}
						fullWidth
						// onChange={_handleChange}
						value={formState.values.northEast || ''}
					/>
				</Grid>
				<Grid item md={3} xs={3}>
					<TextField
						id="northEastLatitude"
						name="northEastLatitude"
						label="Latitude"
						defaultValue=""
						value={formState.values.northEastLatitude || ''}
						fullWidth
						variant="outlined"
						onChange={_handleChange}
					/>
				</Grid>
				<Grid item md={3} xs={3}>
					<TextField
						id="northEastLongitude"
						name="northEastLongitude"
						label="Longitude"
						defaultValue=""
						value={formState.values.northEastLongitude || ''}
						fullWidth
						variant="outlined"
						onChange={_handleChange}
					/>
				</Grid>
			</Grid>
			{/* New row */}
			<Grid container spacing={3}>
				<Grid item md={2} xs={2}>
					<TextField
						id="southWest"
						label="SouthWest"
						name="southWest"
						InputProps={{
							readOnly: true,
						}}
						fullWidth
						// onChange={_handleChange}
						value={formState.values.southWest || ''}
					/>
				</Grid>
				<Grid item md={3} xs={3}>
					<TextField
						id="southWestLatitude"
						name="southWestLatitude"
						label="Latitude"
						defaultValue=""
						value={formState.values.southWestLatitude || ''}
						fullWidth
						variant="outlined"
						onChange={_handleChange}
					/>
				</Grid>
				<Grid item md={3} xs={3}>
					<TextField
						id="southWestLongitude"
						name="southWestLongitude"
						label="Longitude"
						defaultValue=""
						value={formState.values.southWestLongitude || ''}
						fullWidth
						variant="outlined"
						onChange={_handleChange}
					/>
				</Grid>
			</Grid>
		</div>
	);
};

export default ByCoordinates;
